export const ScoreType = Object.freeze({
  Eligibility: {
    value: 'Eligibility',
    label: 'Eligibility',
  },
  MemoryImpairmentScreen: {
    value: 'MemoryImpairmentScreen',
    label: 'Memory Impairment Screen',
  },
  MoCABlind: {
    value: 'MoCABlind',
    label: 'MoCA-Blind',
  },
  CognitiveClinicalInterview: {
    value: 'CognitiveClinicalInterview',
    label: 'Risk Level',
  },
  MindyScreeningResult: {
    value: 'MindyScreeningResult',
    label: 'Mindy Screening Result',
  },
  MoCAScreening: {
    value: 'MoCAScreening',
    label: 'MoCA - Digital Patient Unassisted',
  },
  MISScreening: {
    value: 'MISScreening',
    label: 'MIS - Digital Patient Unassisted',
  },
  FullMoCAScreening: {
    value: 'FullMoCAScreening',
    label: 'Full MoCA - Digital Patient Unassisted',
  },
  MoCAScreeningUnassisted: {
    value: 'MoCAScreeningUnassisted',
    label: 'MoCA - Digital Patient Unassisted',
  },
  MISScreeningUnassisted: {
    value: 'MISScreeningUnassisted',
    label: 'MIS - Digital Patient Unassisted',
  },
  FullMoCAScreeningUnassisted: {
    value: 'FullMoCAScreeningUnassisted',
    label: 'Full MoCA - Digital Patient Unassisted',
  },
  MoCAScreeningAssisted: {
    value: 'MoCAScreeningAssisted',
    label: 'MoCA - Digital Patient Assisted',
  },
  MISScreeningAssisted: {
    value: 'MISScreeningAssisted',
    label: 'MIS - Digital Patient Assisted',
  },
  FullMoCAScreeningAssisted: {
    value: 'FullMoCAScreeningAssisted',
    label: 'Full MoCA - Digital Patient Assisted',
  },
  PRO10ScreeningAssisted: {
    value: 'PRO10ScreeningAssisted',
    label: 'PRO-10 - Digital Patient Assisted',
  },
  PRO10ScreeningUnassisted: {
    value: 'PRO10ScreeningUnassisted',
    label: 'PRO-10 - Digital Patient Unassisted',
  },
  ZBI22ScreeningAssisted: {
    value: 'ZBI22ScreeningAssisted',
    label: 'ZBI-22 - Digital Patient Assisted',
  },
  ZBI22ScreeningUnassisted: {
    value: 'ZBI22ScreeningUnassisted',
    label: 'ZBI-22 - Digital Patient Unassisted',
  },
  FAST: {
    value: 'FAST',
    label: 'Functional Assessment Staging Tool (FAST)',
  },
  PRO10Assessment: {
    value: 'PRO10Assessment',
    label: 'PRO-10 Assessment',
  },
  ZBI22Assessment: {
    value: 'ZBI22Assessment',
    label: 'ZBI-22 Assessment',
  },
});
